/**
 * 敏感词和违禁词模块，负责敏感词过滤等功能
 *
 * @author mingxin.huang
 * @update 2014.11.04
 *
 * 公用方法
 *
 * isLegal     : 判断文本是否合法,
 * filterXss   : 过滤XSS，跨域攻击的一些文本,
 * filterWords : 过滤违禁词,
 * filter      : 过滤方法，同时使用，过滤xss和过滤违禁词,
 * isSensitive : 是否含有敏感词
 * isNumberExceed : 字符串中是否超过5个数字
 *
 */

$.module('MM.sensitive', function () {
  var ACTION = 'public/blackword_list/{type}',
    STORE_TAG = 'FORBID_WORDS_V3',
    INTERVAL_TIME = 5 * 60 * 1000,
    _forbidCol = {
      //用于储存
      type_0: {
        //昵称敏感词
        ary: [],
        length: 0,
      },
      type_1: {
        //聊天敏感词
        ary: [],
        length: 0,
      },
      ts: 0,
    };

  function _init() {}

  /**
   * 过滤XSS，跨域攻击的一些文本
   * @param  {[type]} text [description]
   * @return {[type]}      [description]
   */
  function _filterXss(text) {
    return text
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/'/g, '&#39;')
      .replace(/"/g, '&#34;');
  }

  /**
   * 过滤方法，同时使用，过滤xss和过滤违禁词
   * @param  {String} text 文本
   * @return {String}      文本
   */
  function _filter(text) {
    return _filterXss(text);
  }

  /**
   * 将全角转换为半角
   * @param {String} str 文本
   * @return {String} 半角的文本
   */
  function _toCDB(str) {
    if (!str) {
      return '';
    }

    var tmp = '';

    for (var i = 0; i < str.length; i++) {
      if (str.charCodeAt(i) > 65248 && str.charCodeAt(i) < 65375) {
        tmp += String.fromCharCode(str.charCodeAt(i) - 65248);
      } else {
        tmp += String.fromCharCode(str.charCodeAt(i));
      }
    }
    return tmp;
  }

  var MAX_NUMBER_COUNT = 4,
    NUMBER_REG =
      /[\w\d一二三四五六七八九壹贰叁肆伍陆柒捌玖零①②③④⑤⑥⑦⑧⑨⑩㈠㈡㈢㈣㈤㈥㈦㈧㈨㈩⑴⑵⑶⑷⑸⑹⑺⑻⑼⑽❶❷❸❹❺❻❼❽❾❿⒈⒉⒊⒋⒌⒍⒎⒏⒐]{4,}/i;

  /**
   * 判断自己是否包含过多的数字
   * @param  {string}  text           文本
   * @return {Boolean}                [description]
   */
  function _isSelfNumberExceed(text) {
    if (
      MM.user.getRichLv() < 3 &&
      MM.user.isCommonUser() &&
      !/^萌新\d{6}$/.test(text)
    ) {
      return _isNumberExceed(text);
    } else {
      return false;
    }
  }

  /**
   * 判断是否包含过多的数字
   * @param  {string}  text           文本
   * @return {Boolean}                [description]
   */
  function _isNumberExceed(text) {
    text = _toCDB(text);

    return NUMBER_REG.test(text);
  }

  var LIMIT_ILLEGAL_REG =
    /[^\w\d\u4e00-\u9fa5,\\.\/\\'";:<>\\?~!@#$%\^\&\*()_\\-\\+=]+/g;

  /**
   * 3富以下的发言和昵称是否合法
   * @param  {String}  text 文本
   * @return {Boolean}      [description]
   */
  function _isLimitIllegal(text) {
    if (MM.user.getRichLv() < 3 && MM.user.isCommonUser()) {
      text = _toCDB(text);

      var matches = text.match(LIMIT_ILLEGAL_REG);

      return matches && matches.length > 0;
    } else {
      return false;
    }
  }

  var AD_REG = /[加微信\+]{2,}/i;

  /**
   * 是否是广告信息
   * @param  {String}  text 消息文本
   * @return {Boolean}      [description]
   */
  function _isAd(text) {
    return AD_REG.test(text);
    // return _isNumberExceed(text) || AD_REG.test(text);
  }

  //非法的正则
  var ILLEGAL_REG = /[~!@#$%^&*()+`='{}<>,./\?\\\|\[\]\-;:'"]+/;

  /**
   * 判断文本是否合法
   * @param  {String}  text 文本
   * @return {Boolean}
   */
  function _isLegal(text) {
    return !ILLEGAL_REG.test(text);
  }

  return {
    init: _init,
    isLegal: _isLegal,
    isLimitIllegal: _isLimitIllegal,
    filterXss: _filterXss,
    filter: _filter,
    isNumberExceed: _isNumberExceed,
    isSelfNumberExceed: _isSelfNumberExceed,
    isAd: _isAd,
  };
});

$(function () {
  setTimeout(MM.sensitive.init, 5 * 1000);
});
